import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { LANDING_COPY, SIGNIN_HREF, SUBSCRIBE_HREF } from "@/data/landingContent";
import { cn } from "@/lib/utils";
import { Wordmark } from "./Wordmark";
import { Button } from "@/components/ui/button";

export const LandingNav = () => (
  <header className="sticky top-0 z-40 border-b border-neutral-200/80 bg-neutral-50/85 backdrop-blur-md">
    <div className="container mx-auto flex items-center justify-between px-5 py-4 md:px-8">
      <Wordmark />
      <nav className="hidden items-center gap-8 text-sm text-neutral-500 md:flex">
        <a href="#situacoes" className="hover:text-neutral-900">
          {LANDING_COPY.navScenes}
        </a>
        <a href="#como" className="hover:text-neutral-900">
          {LANDING_COPY.navHow}
        </a>
        <a href="#tradutor" className="hover:text-neutral-900">
          {LANDING_COPY.navLive}
        </a>
        <a href="#preco" className="hover:text-neutral-900">
          {LANDING_COPY.navPrice}
        </a>
        <Link to={SIGNIN_HREF} className="hover:text-neutral-900">
          {LANDING_COPY.signIn}
        </Link>
      </nav>
      <Button asChild size="sm" className="landing-cta hidden md:inline-flex">
        <Link to={SUBSCRIBE_HREF}>{LANDING_COPY.cta}</Link>
      </Button>
    </div>
  </header>
);

type PrimaryCtaProps = {
  fullWidth?: boolean;
  href?: string;
  label?: string;
  showMicro?: boolean;
};

export const PrimaryCta = ({
  fullWidth = false,
  href = SUBSCRIBE_HREF,
  label = LANDING_COPY.cta,
  showMicro = true,
}: PrimaryCtaProps) => (
  <div className={fullWidth ? "w-full" : undefined}>
    <Button asChild className={cn("landing-cta", fullWidth && "w-full")}>
      <Link to={href}>{label}</Link>
    </Button>
    {showMicro ? (
      <p className={cn("mt-3 text-sm text-neutral-500", fullWidth && "text-center")}>{LANDING_COPY.micro}</p>
    ) : null}
  </div>
);

export const SecondaryCta = ({ fullWidth = false }: { fullWidth?: boolean }) => (
  <Button asChild variant="secondary" className={cn(fullWidth && "w-full")}>
    <Link to={SIGNIN_HREF}>{LANDING_COPY.ctaSecondary}</Link>
  </Button>
);

export const CloseBand = () => {
  const reduce = useReducedMotion();

  return (
    <section className="container mx-auto px-5 pb-16 md:px-8">
      <motion.div
        className="landing-close flex flex-col gap-6 rounded-[24px] px-6 py-8 text-white md:flex-row md:items-center md:justify-between md:px-10 md:py-10"
        initial={reduce ? false : { opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
      >
        <div>
          <h2 className="text-2xl font-bold tracking-[-0.03em] md:text-3xl">{LANDING_COPY.closeTitle}</h2>
          <p className="mt-2 text-sm text-white/80">{LANDING_COPY.closeMicro}</p>
        </div>
        <Button asChild variant="primary-inverse" className="w-full md:w-auto">
          <Link to={SUBSCRIBE_HREF}>{LANDING_COPY.closeCta}</Link>
        </Button>
      </motion.div>
    </section>
  );
};

export const LandingFooter = () => (
  <footer className="px-5 py-8 text-center text-sm text-neutral-500 md:px-8">
    <p>{LANDING_COPY.footer}</p>
    <div className="mt-3 flex items-center justify-center gap-4">
      <Link to="/privacidade" className="hover:text-neutral-900">
        Privacidade
      </Link>
      <Link to="/excluir-conta" className="hover:text-neutral-900">
        Excluir conta
      </Link>
    </div>
  </footer>
);
